import * as R from 'ramda';

export type TourStep = {
  step: string;
  content: () => void;
  selector?: string;
  position?: string;
  current?: string;
  isCompleted?: boolean;
};

const tourSteps = [
  {
    step: 'thanks_bar',
    content: () => (
      {
        title: 'Thanks for choosing GymCloud!',
        main: `
          At GymCloud, our mission is to enhance the training experience between fitness professionals and clients.
          To accomplish that, we’ve provided you with all the tools you and your clients need to achieve fitness success.
          Let’s take a quick look around.
        `,
      }
    ),
    position: 'center',
  },
  {
    step: 'navigation_bar',
    selector: '[data-tour="tour__nav"]',
    content: () => (
      {
        title: 'Navigation',
        main: `
         This menu is where you’ll navigate through GymCloud and access its core features. The dropdown arrows enable you to quickly find specific items in each category.
         You can easily access your library of <b>Exercises</b>, master <b>Workouts</b> and <b>Programs</b>, and your videos.
        `,
      }
    ),
  },
  {
    step: 'navigation_bar',
    selector: '[data-tour="tour__nav"]',
    content: () => (
      {
        title: 'Navigation',
        main: `
         In the <b>Clients</b> section, you can manage client profiles, groups, and assigned workouts and programs.
         You can quickly navigate to your <b>Calendar</b> for scheduling, or set up the <b>Metrics</b> (sets, reps, etc.) you will use to measure progress.
         Click <b>My Training Log</b> to find the fitness programs you have assigned to yourself.
        `,
      }
    ),
  },
  {
    step: 'profile_avatar',
    selector: '[data-tour="tour__profile"]',
    content: () => (
      {
        title: 'Profile',
        main: 'Click your <b>profile image</b> to edit your profile info, update payment options, or log out.',
      }
    ),
  },
  {
    step: 'help_icon',
    selector: '[data-tour="tour__help"]',
    content: () => (
      {
        title: 'Help Center',
        main: `
          Got questions? We’ve got answers.
          Access our <b>help center</b> using the “?” icon beside your profile image and click on Go to Support Portal.
          Here you can access a library of tutorial articles, or you can quickly get help from Jim, our support bot, by clicking the <b>Support Bot</b> icon in the lower corner of your screen and entering your question.
        `,
      }
    ),
  },
  {
    step: 'next_steps',
    content: () => (
      {
        title: 'Next Steps',
        main: `
          Now let’s begin building your online personal training business.
          The <b>dashboard tutorial</b> will introduce you to the fundamentals of online training.
        `,
      }
    ),
    position: 'center',
  },
];

export const getTourSteps = (userSteps: string[]) => {
  const completed = R.intersection(
    tourSteps.map(s => s.step),
    userSteps,
  );

  return tourSteps.reduce((acc, item) => [
    ...acc,
    {
      ...item,
      isCompleted: completed.indexOf(item.step) !== -1,
    },
  ], []);
};
